import FirestoreClient from "@/connectors/firebase/firestore/firestore.client";
import FirestoreService from "@/connectors/firebase/firestore/firestore.service";
import fb from "@/connectors/firebase/config";

FirestoreClient.initialize(fb);

const db = FirestoreClient.getInstance();
const dbHelper = new FirestoreService(db);

export {dbHelper};
